import { parseFloat, parseNumber, transformModel } from '~/src/dash/api/resource-transforms';
import { addDomainAndTokenToUrl, restGet } from '~/src/dash/api/rest';
import { ISimpleOption } from '~/src/dash/publicaUI';
import { IMenuList } from '~/src/dash/types/menuList';

export interface IExchangeRate {
  ID: number;
  CreatedAt?: string;
  UpdatedAt?: string;
  DeletedAt?: string;

  CurrencyType: ECurrencyType;
  ExchangeValueToUSD: number;
}

export type CurrencyType = string;
export const CurrencyTypeUSD: CurrencyType = 'USD';
export const CurrencyTypeCAD: CurrencyType = 'CAD';
export const CurrencyTypeEUR: CurrencyType = 'EUR';
export const CurrencyTypeJPY: CurrencyType = 'JPY';
export const CurrencyTypeHKD: CurrencyType = 'HKD';
export const CurrencyTypeSGD: CurrencyType = 'SGD';
export const CurrencyTypeAUD: CurrencyType = 'AUD';
export const CurrencyTypeNZD: CurrencyType = 'NZD';
export const CurrencyTypeTWD: CurrencyType = 'TWD';
export const CurrencyTypeKRW: CurrencyType = 'KRW';
export const CurrencyTypePHP: CurrencyType = 'PHP';
export const CurrencyTypeIDR: CurrencyType = 'IDR';
export const CurrencyTypeINR: CurrencyType = 'INR';
export const CurrencyTypeCNY: CurrencyType = 'CNY';
export const CurrencyTypeMYR: CurrencyType = 'MYR';
export const CurrencyTypeTHB: CurrencyType = 'THB';
export const CurrencyTypeARS: CurrencyType = 'ARS';
export const CurrencyTypeBOB: CurrencyType = 'BOB';
export const CurrencyTypeBRL: CurrencyType = 'BRL';
export const CurrencyTypeCLP: CurrencyType = 'CLP';
export const CurrencyTypeCOP: CurrencyType = 'COP';
export const CurrencyTypeFKP: CurrencyType = 'FKP';
export const CurrencyTypeGYD: CurrencyType = 'GYD';
export const CurrencyTypePYG: CurrencyType = 'PYG';
export const CurrencyTypePEN: CurrencyType = 'PEN';
export const CurrencyTypeGBP: CurrencyType = 'GBP';
export const CurrencyTypeSRD: CurrencyType = 'SRD';
export const CurrencyTypeUYU: CurrencyType = 'UYU';
export const CurrencyTypeMXN: CurrencyType = 'MXN';
export const CurrencyTypeCHF: CurrencyType = 'CHF';

export enum ECurrencyType {
  CURRENCY_TYPE_USD = 0,
  CURRENCY_TYPE_CAD,
  CURRENCY_TYPE_EUR,
  CURRENCY_TYPE_JPY,
  CURRENCY_TYPE_HKD,
  CURRENCY_TYPE_SGD,
  CURRENCY_TYPE_AUD,
  CURRENCY_TYPE_NZD,
  CURRENCY_TYPE_TWD,
  CURRENCY_TYPE_KRW,
  CURRENCY_TYPE_PHP,
  CURRENCY_TYPE_IDR,
  CURRENCY_TYPE_INR,
  CURRENCY_TYPE_CNY,
  CURRENCY_TYPE_MYR,
  CURRENCY_TYPE_THB,
  CURRENCY_TYPE_ARS,
  CURRENCY_TYPE_BOB,
  CURRENCY_TYPE_BRL,
  CURRENCY_TYPE_CLP,
  CURRENCY_TYPE_COP,
  CURRENCY_TYPE_FKP,
  CURRENCY_TYPE_GYD,
  CURRENCY_TYPE_PYG,
  CURRENCY_TYPE_PEN,
  CURRENCY_TYPE_GBP,
  CURRENCY_TYPE_SRD,
  CURRENCY_TYPE_UYU,
  CURRENCY_TYPE_MXN,
  CURRENCY_TYPE_CHF,
}

export const convertECurrencyTypeToString = (type: ECurrencyType): CurrencyType => {
  switch (type) {
    case ECurrencyType.CURRENCY_TYPE_USD:
      return CurrencyTypeUSD;
    case ECurrencyType.CURRENCY_TYPE_CAD:
      return CurrencyTypeCAD;
    case ECurrencyType.CURRENCY_TYPE_EUR:
      return CurrencyTypeEUR;
    case ECurrencyType.CURRENCY_TYPE_JPY:
      return CurrencyTypeJPY;
    case ECurrencyType.CURRENCY_TYPE_HKD:
      return CurrencyTypeHKD;
    case ECurrencyType.CURRENCY_TYPE_SGD:
      return CurrencyTypeSGD;
    case ECurrencyType.CURRENCY_TYPE_AUD:
      return CurrencyTypeAUD;
    case ECurrencyType.CURRENCY_TYPE_NZD:
      return CurrencyTypeNZD;
    case ECurrencyType.CURRENCY_TYPE_TWD:
      return CurrencyTypeTWD;
    case ECurrencyType.CURRENCY_TYPE_KRW:
      return CurrencyTypeKRW;
    case ECurrencyType.CURRENCY_TYPE_PHP:
      return CurrencyTypePHP;
    case ECurrencyType.CURRENCY_TYPE_IDR:
      return CurrencyTypeIDR;
    case ECurrencyType.CURRENCY_TYPE_INR:
      return CurrencyTypeINR;
    case ECurrencyType.CURRENCY_TYPE_CNY:
      return CurrencyTypeCNY;
    case ECurrencyType.CURRENCY_TYPE_MYR:
      return CurrencyTypeMYR;
    case ECurrencyType.CURRENCY_TYPE_THB:
      return CurrencyTypeTHB;
    case ECurrencyType.CURRENCY_TYPE_ARS:
      return CurrencyTypeARS;
    case ECurrencyType.CURRENCY_TYPE_BOB:
      return CurrencyTypeBOB;
    case ECurrencyType.CURRENCY_TYPE_BRL:
      return CurrencyTypeBRL;
    case ECurrencyType.CURRENCY_TYPE_CLP:
      return CurrencyTypeCLP;
    case ECurrencyType.CURRENCY_TYPE_COP:
      return CurrencyTypeCOP;
    case ECurrencyType.CURRENCY_TYPE_FKP:
      return CurrencyTypeFKP;
    case ECurrencyType.CURRENCY_TYPE_GYD:
      return CurrencyTypeGYD;
    case ECurrencyType.CURRENCY_TYPE_PYG:
      return CurrencyTypePYG;
    case ECurrencyType.CURRENCY_TYPE_PEN:
      return CurrencyTypePEN;
    case ECurrencyType.CURRENCY_TYPE_GBP:
      return CurrencyTypeGBP;
    case ECurrencyType.CURRENCY_TYPE_SRD:
      return CurrencyTypeSRD;
    case ECurrencyType.CURRENCY_TYPE_UYU:
      return CurrencyTypeUYU;
    case ECurrencyType.CURRENCY_TYPE_MXN:
      return CurrencyTypeMXN;
    case ECurrencyType.CURRENCY_TYPE_CHF:
      return CurrencyTypeCHF;
  }
};

export const convertStringToECurrencyType = (type: CurrencyType): ECurrencyType => {
  switch (type) {
    case CurrencyTypeUSD:
      return ECurrencyType.CURRENCY_TYPE_USD;
    case CurrencyTypeCAD:
      return ECurrencyType.CURRENCY_TYPE_CAD;
    case CurrencyTypeEUR:
      return ECurrencyType.CURRENCY_TYPE_EUR;
    case CurrencyTypeJPY:
      return ECurrencyType.CURRENCY_TYPE_JPY;
    case CurrencyTypeHKD:
      return ECurrencyType.CURRENCY_TYPE_HKD;
    case CurrencyTypeSGD:
      return ECurrencyType.CURRENCY_TYPE_SGD;
    case CurrencyTypeAUD:
      return ECurrencyType.CURRENCY_TYPE_AUD;
    case CurrencyTypeNZD:
      return ECurrencyType.CURRENCY_TYPE_NZD;
    case CurrencyTypeTWD:
      return ECurrencyType.CURRENCY_TYPE_TWD;
    case CurrencyTypeKRW:
      return ECurrencyType.CURRENCY_TYPE_KRW;
    case CurrencyTypePHP:
      return ECurrencyType.CURRENCY_TYPE_PHP;
    case CurrencyTypeIDR:
      return ECurrencyType.CURRENCY_TYPE_IDR;
    case CurrencyTypeINR:
      return ECurrencyType.CURRENCY_TYPE_INR;
    case CurrencyTypeCNY:
      return ECurrencyType.CURRENCY_TYPE_CNY;
    case CurrencyTypeMYR:
      return ECurrencyType.CURRENCY_TYPE_MYR;
    case CurrencyTypeTHB:
      return ECurrencyType.CURRENCY_TYPE_THB;
    case CurrencyTypeARS:
      return ECurrencyType.CURRENCY_TYPE_ARS;
    case CurrencyTypeBOB:
      return ECurrencyType.CURRENCY_TYPE_BOB;
    case CurrencyTypeBRL:
      return ECurrencyType.CURRENCY_TYPE_BRL;
    case CurrencyTypeCLP:
      return ECurrencyType.CURRENCY_TYPE_CLP;
    case CurrencyTypeCOP:
      return ECurrencyType.CURRENCY_TYPE_COP;
    case CurrencyTypeFKP:
      return ECurrencyType.CURRENCY_TYPE_FKP;
    case CurrencyTypeGYD:
      return ECurrencyType.CURRENCY_TYPE_GYD;
    case CurrencyTypePYG:
      return ECurrencyType.CURRENCY_TYPE_PYG;
    case CurrencyTypePEN:
      return ECurrencyType.CURRENCY_TYPE_PEN;
    case CurrencyTypeGBP:
      return ECurrencyType.CURRENCY_TYPE_GBP;
    case CurrencyTypeSRD:
      return ECurrencyType.CURRENCY_TYPE_SRD;
    case CurrencyTypeUYU:
      return ECurrencyType.CURRENCY_TYPE_UYU;
    case CurrencyTypeMXN:
      return ECurrencyType.CURRENCY_TYPE_MXN;
    case CurrencyTypeCHF:
      return ECurrencyType.CURRENCY_TYPE_CHF;
  }
  return ECurrencyType.CURRENCY_TYPE_USD;
};

export const convertECurrencyTypeToSymbol = (type: ECurrencyType): CurrencyType => {
  switch (type) {
    case ECurrencyType.CURRENCY_TYPE_USD:
      return '$';
    case ECurrencyType.CURRENCY_TYPE_CAD:
      return 'C$';
    case ECurrencyType.CURRENCY_TYPE_EUR:
      return '€';
    case ECurrencyType.CURRENCY_TYPE_JPY:
      return '¥';
    case ECurrencyType.CURRENCY_TYPE_HKD:
      return 'HK$';
    case ECurrencyType.CURRENCY_TYPE_SGD:
      return 'SG$';
    case ECurrencyType.CURRENCY_TYPE_AUD:
      return 'AU$';
    case ECurrencyType.CURRENCY_TYPE_NZD:
      return 'NZ$';
    case ECurrencyType.CURRENCY_TYPE_TWD:
      return 'TW$';
    case ECurrencyType.CURRENCY_TYPE_KRW:
      return '₩';
    case ECurrencyType.CURRENCY_TYPE_PHP:
      return '₱';
    case ECurrencyType.CURRENCY_TYPE_IDR:
      return 'IDR';
    case ECurrencyType.CURRENCY_TYPE_INR:
      return 'INR';
    case ECurrencyType.CURRENCY_TYPE_CNY:
      return '¥';
    case ECurrencyType.CURRENCY_TYPE_MYR:
      return 'RM';
    case ECurrencyType.CURRENCY_TYPE_THB:
      return '฿';
    case ECurrencyType.CURRENCY_TYPE_ARS:
      return 'AR$';
    case ECurrencyType.CURRENCY_TYPE_BOB:
      return 'BOB';
    case ECurrencyType.CURRENCY_TYPE_BRL:
      return 'R$';
    case ECurrencyType.CURRENCY_TYPE_CLP:
      return 'CLP';
    case ECurrencyType.CURRENCY_TYPE_COP:
      return 'COP';
    case ECurrencyType.CURRENCY_TYPE_FKP:
      return 'FK£';
    case ECurrencyType.CURRENCY_TYPE_GYD:
      return 'GY$';
    case ECurrencyType.CURRENCY_TYPE_PYG:
      return 'PY$';
    case ECurrencyType.CURRENCY_TYPE_PEN:
      return 'S/';
    case ECurrencyType.CURRENCY_TYPE_GBP:
      return '£';
    case ECurrencyType.CURRENCY_TYPE_SRD:
      return 'SR$';
    case ECurrencyType.CURRENCY_TYPE_UYU:
      return '$U';
    case ECurrencyType.CURRENCY_TYPE_MXN:
      return 'Mex$';
    case ECurrencyType.CURRENCY_TYPE_CHF:
      return 'CHf';
  }
};

export const convertStringToCurrencySymbol = (type: CurrencyType): string => {
  return convertECurrencyTypeToSymbol(convertStringToECurrencyType(type));
};

export const CurrencyDisplayedItem = [
  { label: 'US Dollar', value: CurrencyTypeUSD, id: 0 },
  { label: 'Canadian Dollar', value: CurrencyTypeCAD, id: 1 },
  { label: 'Euro', value: CurrencyTypeEUR, id: 2 },
  { label: 'Japanese Yen', value: CurrencyTypeJPY, id: 3 },
  { label: 'Hong Kong Dollar', value: CurrencyTypeHKD, id: 4 },
  { label: 'Singapore Dollar', value: CurrencyTypeSGD, id: 5 },
  { label: 'Australian Dollar', value: CurrencyTypeAUD, id: 6 },
  { label: 'New Zeal Dollar', value: CurrencyTypeNZD, id: 7 },
  { label: 'Taiwan Dollar', value: CurrencyTypeTWD, id: 8 },
  { label: 'Korean Won', value: CurrencyTypeKRW, id: 9 },
  { label: 'Philippine Peso', value: CurrencyTypePHP, id: 10 },
  { label: 'Indian Rupee', value: CurrencyTypeINR, id: 12 },
  { label: 'Indonesian Rupiah', value: CurrencyTypeIDR, id: 11 },
  { label: 'Chinese Yuan', value: CurrencyTypeCNY, id: 13 },
  { label: 'Malaysian Ringgit', value: CurrencyTypeMYR, id: 14 },
  { label: 'Thai Baht', value: CurrencyTypeTHB, id: 15 },
  { label: 'Argentine Peso', value: CurrencyTypeARS, id: 16 },
  { label: 'Bolivian Boliviano', value: CurrencyTypeBOB, id: 17 },
  { label: 'Brazilian Real', value: CurrencyTypeBRL, id: 18 },
  { label: 'Chilean Peso', value: CurrencyTypeCLP, id: 19 },
  { label: 'Colombian Peso', value: CurrencyTypeCOP, id: 20 },
  { label: 'Falkland Islands Pound', value: CurrencyTypeFKP, id: 21 },
  { label: 'Guyanaese Dollar', value: CurrencyTypeGYD, id: 22 },
  { label: 'Paraguayan Guarani', value: CurrencyTypePYG, id: 23 },
  { label: 'Peru Sol', value: CurrencyTypePEN, id: 24 },
  { label: 'British Pound ', value: CurrencyTypeGBP, id: 25 },
  { label: 'Surimanmese Dollar', value: CurrencyTypeSRD, id: 26 },
  { label: 'Uruguayan Peso', value: CurrencyTypeUYU, id: 27 },
  { label: 'Mexican Peso', value: CurrencyTypeMXN, id: 28 },
  { label: 'Swiss Franc', value: CurrencyTypeCHF, id: 29 },
];

export const transformExchangeRate = transformModel<IExchangeRate>({
  ID: parseNumber(['ID']),
  CreatedAt: 'CreatedAt',
  UpdatedAt: 'UpdatedAt',
  DeletedAt: 'DeletedAt',

  CurrencyType: parseNumber(['CurrencyType']),
  ExchangeValueToUSD: parseFloat(['ExchangeValueToUSD']),
});

export function genCurrencyList(currencyDisplayed: ECurrencyType) {
  const currencyList: IMenuList = {};
  Object.values(CurrencyDisplayedItem).forEach((item) => {
    currencyList[item.label] = {
      title: item.label,
      selected: item.id === currencyDisplayed ? true : false,
      ID: item.label,
      defaultWeight: item.id,
    };
  });
  return currencyList;
}

export async function getExchangeRate(currencyDisplayed: ECurrencyType): Promise<IExchangeRate> {
  const reqUrl = addDomainAndTokenToUrl(`/exchange_rate/${currencyDisplayed}`);
  try {
    const response = await restGet<any>(reqUrl);
    return response?.parsedBody || {};
  } catch (err) {
    throw err;
  }
}

export async function fetchExchangeRates(): Promise<Array<IExchangeRate>> {
  const reqUrl = addDomainAndTokenToUrl(`/exchange_rates`);
  try {
    const response = await restGet<any>(reqUrl, {});
    return response.parsedBody;
  } catch (err) {
    throw err;
  }
}

export const currencies: Array<ISimpleOption> = CurrencyDisplayedItem.map((currency) => {
  return {
    key: 'currency',
    label: currency.label,
    value: currency.value,
  };
});
